(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-exhibition"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var galleryEl = document.querySelectorAll('[data-product-gallery]');
    if (galleryEl.length > 0) {
      galleryEl.forEach(function (gallery) {
        new Swiper(gallery, {
          slidesPerView: 1,
          spaceBetween: 0,
          mousewheel: {
            enable: true,
            forceToAxis: true,
          },
          navigation: {
            nextEl: gallery.querySelector('[data-gallery-next]'),
            prevEl: gallery.querySelector('[data-gallery-prev]'),
          },
        });
      });
    }

    var eventCarousels = document.querySelectorAll('[data-related-media]');
    if (eventCarousels.length > 0) {
      eventCarousels.forEach(function (eventCarousel) {
        new Swiper(eventCarousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          mousewheel: {
            enable: true,
            forceToAxis: true,
          },
          breakpoints: {
            1024: {
              slidesPerView: 'auto',
              spaceBetween: 30,
            },
          },
        });
      });
    }

    function updateHeaderSpace() {
      const header = document.querySelector('[data-site-header]');
      const exhibitionArticle = document.querySelector('.exhibition-article');
      if (exhibitionArticle && header) {
        const headerHeight = header.offsetHeight;
        const newHeaderSpace = window.innerWidth >= 640 ? '0px' : headerHeight + 'px';
        exhibitionArticle.style.setProperty('--header-space', newHeaderSpace);
      }
    }

    updateHeaderSpace();
    window.addEventListener('resize', updateHeaderSpace);

    const players = document.querySelectorAll('[data-player]');
    var plyrs = [];
    if (players.length > 0) {
      players.forEach((player) => {
        const instance = new Plyr(player);
        plyrs[instance.id] = instance;
      });
    }

    Fancybox.bind('[data-fancybox]', {
      on: {
        closing: () => {
          if (players.length > 0) {
            plyrs.forEach((player) => {
              player.stop();
            });
          }
        },
        done: () => {
          if (players.length > 0) {
            plyrs.forEach((player) => {
              player.stop();
            });
          }
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const players = document.querySelectorAll('[data-player]');
    var plyrs = [];
    if (players.length > 0) {
      players.forEach((player) => {
        const instance = new Plyr(player);
        plyrs[instance.id] = instance;
      });
    }
    //console.log(plyrs);

    Fancybox.bind('[data-fancybox]', {
      on: {
        closing: () => {
          if (players.length > 0) {
            plyrs.forEach((player) => {
              player.stop();
            });
          }
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const players = document.querySelectorAll('[data-player]');
    var plyrs = [];
    if (players.length > 0) {
      players.forEach((player) => {
        const instance = new Plyr(player);
        plyrs[instance.id] = instance;
      });
    }
    //console.log(plyrs);

    Fancybox.bind('[data-fancybox]', {
      on: {
        closing: () => {
          if (players.length > 0) {
            plyrs.forEach((player) => {
              player.stop();
            });
          }
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', function (e) {
    const form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    if (form.contains(e.target) && e.target.type === 'checkbox') {
      form.submit();
    }
  });
  let priceTimeout;
  document.querySelectorAll('#CollectionFiltersForm [name*="filter.v.price"]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      clearTimeout(priceTimeout);
      priceTimeout = setTimeout(function () {
        const form = document.getElementById('CollectionFiltersForm');
        if (form) form.submit();
      }, 600);
    });
  });
  // Updated sort handler: sync hidden input then submit form
  (function () {
    var sortSel = document.querySelector('[data-collection-sort]');
    if (!sortSel) return;
    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    var hidden = form.querySelector('#SortByInput');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'sort_by';
      hidden.id = 'SortByInput';
      form.appendChild(hidden);
    }
    sortSel.addEventListener('change', function () {
      if (this.value === 'best-selling') {
        hidden.value = '';
        hidden.disabled = true; // omit param for default
      } else {
        hidden.disabled = false;
        hidden.value = this.value;
      }
      // remove page param from URL before submit (so it resets to page 1)
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      window.history.replaceState({}, '', url.toString());
      form.submit();
    });
  })();
  // Mobile filter open/close handling (adds/removes is-filter-open on <1280px)
  (function () {
    const OPEN_ATTR = '[data-filter-open]';
    const CLOSE_ATTR = '[data-filter-close]';
    const CLOSE_ELEMENTS = document.querySelectorAll(CLOSE_ATTR);
    const BODY_CLASS = 'is-filter-open';
    const MOBILE_MAX = 1280; // matches xl breakpoint

    function isMobile() {
      return window.innerWidth < MOBILE_MAX;
    }

    function openFilters() {
      if (isMobile()) document.body.classList.add(BODY_CLASS);
    }

    function closeFilters() {
      document.body.classList.remove(BODY_CLASS);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest(OPEN_ATTR)) {
        e.preventDefault();
        openFilters();
      } else if (e.target.closest(CLOSE_ATTR)) {
        e.preventDefault();
        closeFilters();
      }
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        // Ensure class removed when transitioning to desktop
        closeFilters();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drawer-search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function sideSearchScripts() {
      if (document.body.hasAttribute('data-side-search-initialized')) return;
      document.body.setAttribute('data-side-search-initialized', 'true');

      const searchSection = document.querySelector('[data-search-section]');
      const overlay = document.querySelector('[data-search-overlay]');
      const closeButton = document.querySelector('[data-search-close]');
      const form = document.querySelector('[data-search-form]');
      const searchInput = document.querySelector('[data-search-input]');
      const resultWrapper = document.querySelector('[data-search-result]');
      const viewAllLabel = resultWrapper.dataset.labelViewall;
      const resultsLabel = resultWrapper.dataset.labelResult;
      let keyUp = Number(searchInput.dataset.keyUp);
      if (!Number.isFinite(keyUp)) {
        keyUp = 3; // Default to 3 if not set or invalid
      }

      document.body.addEventListener('click', function (event) {
        if (event.target.matches('[data-search-toggle]')) {
          event.preventDefault();
          document.body.classList.toggle('is-search-open');
        }
      });

      if (overlay) {
        overlay.addEventListener('click', function () {
          document.body.classList.remove('is-search-open');
        });
      }
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          document.body.classList.remove('is-search-open');
        });
      }

      if (searchInput && form && resultWrapper) {
        let activeController = null;

        const STATE_CLASSES = [
          'is-search-loading',
          'is-search-loaded',
          'is-search-success',
          'is-search-error',
          'is-term-short',
          'is-default',
        ];

        function applyState(stateClass, { busy = false } = {}) {
          STATE_CLASSES.forEach((c) => searchSection.classList.remove(c));
          if (stateClass) {
            searchSection.classList.add(stateClass);
          }
          if (busy) {
            searchSection.setAttribute('aria-busy', 'true');
          } else {
            searchSection.removeAttribute('aria-busy');
          }
        }

        function setShortState() {
          resultWrapper.innerHTML = '';
          if (!searchInput.value.trim()) {
            applyState('is-default');
          } else {
            applyState('is-term-short');
          }
        }

        function startLoading() {
          applyState('is-search-loading', { busy: true });
        }

        function finishLoading(hasResults) {
          if (hasResults) {
            applyState('is-search-success');
          } else {
            applyState('is-search-error');
          }
        }

        // Initialize with default state when drawer opens / script loads
        setShortState();

        searchInput.addEventListener('keyup', (e2) => {
          const value = e2.target.value.trim();

          if (value.length < keyUp) {
            if (activeController) {
              activeController.abort();
              activeController = null;
            }
            setShortState();
            return;
          }

          if (activeController) activeController.abort();
          activeController = new AbortController();

          startLoading();

          fetch(
            '/search/suggest?q=' +
              encodeURIComponent(value) +
              '&resources[type]=product&resources[options][fields]=title,product_type,vendor,variants.sku' +
              '&section_id=predictive-search&view_all_label=' +
              encodeURIComponent(viewAllLabel) +
              '&results_label=' +
              encodeURIComponent(resultsLabel),
            {
              signal: activeController.signal,
            }
          )
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((text) => {
              const parsed = new DOMParser().parseFromString(text, 'text/html');
              const source = parsed.querySelector('#shopify-section-predictive-search');
              if (source) {
                resultWrapper.innerHTML = source.innerHTML;
                const button = resultWrapper.querySelector('[data-search-button]');
                const spanViewAll = resultWrapper.querySelector('[data-label-viewall]');
                if (button) {
                  // ensure label applied (fallback if section didn't use param)
                  if (!spanViewAll.textContent.trim()) {
                    spanViewAll.textContent = viewAllLabel;
                  } else {
                    spanViewAll.textContent = viewAllLabel;
                  }
                  button.addEventListener(
                    'click',
                    (e3) => {
                      e3.preventDefault();
                      form.submit();
                    },
                    { once: true }
                  );
                }
                const hasResults = resultWrapper.textContent.trim().length > 0;
                finishLoading(hasResults);
              } else {
                resultWrapper.innerHTML = '';
                finishLoading(false);
              }
            })
            .catch((error) => {
              if (error.name === 'AbortError') return;
              console.warn('Predictive search error:', error);
              resultWrapper.innerHTML = '';
              finishLoading(false);
            });
        });
      }

      // Unified Add-to-Cart handlers for search (supports multiple and dynamic buttons)
      (function setupSearchAddToCartHandlers() {
        var lastProcessingBtn = null;
        var canOpenSideCart = false;

        // Delegate click to capture current and future buttons
        document.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-add-to-cart-search]');
          if (!btn) return;
          if (btn.disabled || btn.classList.contains('is-unavailable')) return;

          lastProcessingBtn = btn;
          btn.classList.add('is-cart-processing');
          canOpenSideCart = true;
        });

        function clearProcessingState() {
          if (!canOpenSideCart) return;
          if (lastProcessingBtn) {
            lastProcessingBtn.classList.remove('is-cart-processing');
            lastProcessingBtn = null;
          }
          // Ensure any leftover buttons are reset (in case of DOM swaps)
          document.querySelectorAll('[data-add-to-cart-search].is-cart-processing').forEach(function (b) {
            b.classList.remove('is-cart-processing');
          });

          // Only open side cart if it was triggered by an add-to-cart action
          document.body.classList.remove('is-search-open');
          document.body.classList.add('is-sidecart-open');
          //console.log('Side cart opened from search add-to-cart action');

          document.body.classList.remove('is-search-open');
          document.body.classList.add('is-sidecart-open');

          canOpenSideCart = false;
        }

        // Remove loading state when Ajax Cart request ends (success or failure)
        document.addEventListener('liquid-ajax-cart:request-end', clearProcessingState);
        document.addEventListener('liquid-ajax-cart:error', clearProcessingState);
      })();
    }

    sideSearchScripts();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exhibition-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var eventCarousels = document.querySelectorAll('[data-carousel="exhibition"]');
    if (eventCarousels.length > 0) {
      eventCarousels.forEach(function (eventCarousel) {
        new Swiper(eventCarousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          mousewheel: {
            enable: true,
            forceToAxis: true,
          },
          breakpoints: {
            1024: {
              slidesPerView: 'auto',
              spaceBetween: 30,
            },
          },
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function calculateHeaderHeight() {
      const header = document.querySelector('[data-site-header]');
      if (header) {
        const headerHeight = header.offsetHeight;
        document.querySelector('[data-header-space]').style.setProperty('--header-space', headerHeight + 'px');
        return headerHeight;
      }
    }

    calculateHeaderHeight();
    window.addEventListener('resize', calculateHeaderHeight);

    function handleScroll() {
      const headerHeight = calculateHeaderHeight();
      const header = document.querySelector('[data-site-header]');
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollTop > headerHeight) {
        header.classList.add('bg-white/90', 'backdrop-blur-sm');
      } else {
        header.classList.remove('bg-white/90', 'backdrop-blur-sm');
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    }
    let lastScrollTop = 0;

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Side search toggle
    var searchToggleButton = document.querySelector('[data-search-toggle]');
    var searchToggle = function () {
      document.body.classList.toggle('is-search-open');
    };
    if (searchToggleButton) {
      searchToggleButton.addEventListener('click', searchToggle);
    }
    const mainMenu = document.querySelector('[data-main-menu]');
    if (mainMenu) {
      const parentMenus = mainMenu.querySelectorAll('[data-parent-menu]');
      const childrenMenus = mainMenu.querySelectorAll('[data-children-menu]');
      if (childrenMenus.length > 0) {
        const setChildrenMenuPadding = () => {
          const container = document.querySelector('.container');
          if (!container) return;
          const containerOffset = (window.innerWidth - container.offsetWidth) / 2;
          childrenMenus.forEach((childrenMenu) => {
            if (parentMenus.length > 0) {
              const parentMenu = Array.from(parentMenus).find(
                (parent) => parent.dataset.parentMenu === childrenMenu.dataset.childrenMenu
              );
              if (parentMenu) {
                childrenMenu.style.setProperty('--spacing-left', `${parentMenu.offsetLeft - containerOffset}px`);
              }
            }
          });
        };
        setChildrenMenuPadding();
        window.addEventListener('resize', setChildrenMenuPadding);
      }
    }

    // Mobile menu.
    const mobileMenuWrapper = document.querySelector('[data-mobile-menu]');
    const mobileToggle = document.querySelector('[data-mobile-toggle]');
    if (mobileMenuWrapper && mobileToggle) {
      const siteHeader = document.querySelector('[data-site-header]');
      mobileMenuWrapper.style.setProperty('--header-space', siteHeader.offsetHeight + 'px');
      mobileToggle.addEventListener('click', function () {
        if (document.body.classList.contains('mobile-menu-visible')) {
          document.body.classList.remove('mobile-menu-visible');
        } else {
          document.body.classList.add('mobile-menu-visible');
        }
      });
      const desktopMenuItems = document.querySelectorAll('[data-menu-item]');
      if (desktopMenuItems.length > 0) {
        desktopMenuItems.forEach((desktopMenuItem) => {
          const mobileMenuContent = document.querySelector('[data-mobile-menu-content]');
          if (!mobileMenuContent) return;
          const desktopMenuLink = desktopMenuItem.querySelector('[data-parent-menu]');
          if (desktopMenuLink) {
            //console.log(desktopMenuLink.dataset.children);
            if (desktopMenuLink.dataset.children === 'false') {
              const mobileMenuLink = document.createElement('a');
              mobileMenuLink.classList.add(
                'block',
                'border-b',
                'border-primary/5',
                'py-4',
                'text-lg',
                'last:border-0',
                'font-medium'
              );
              mobileMenuLink.href = desktopMenuLink.href;
              mobileMenuLink.innerHTML = desktopMenuLink.innerHTML;
              mobileMenuLink.classList.add('mobile-menu-link');
              mobileMenuContent.appendChild(mobileMenuLink);
            } else {
              const megaMenuItem = desktopMenuItem.querySelector('[data-children-menu]');
              if (megaMenuItem) {
                const megaChildrenItems = megaMenuItem.querySelectorAll('a');
                // Details
                const mobileMenuDetails = document.createElement('details');
                mobileMenuDetails.classList.add('border-b', 'border-primary/5', 'last:border-0', 'group');
                // Summary
                const mobileMenuSummary = document.createElement('summary');
                mobileMenuSummary.classList.add(
                  'cursor-pointer',
                  'py-4',
                  'text-lg',
                  'flex',
                  'items-center',
                  'justify-between',
                  'gap-4',
                  'font-medium',
                  'cursor-pointer',
                  'select-none'
                );
                mobileMenuSummary.innerHTML = desktopMenuLink.innerHTML;
                // Summary toggle icon
                const summaryToggle = document.createElement('span');
                summaryToggle.classList.add('w-4', 'h-4', 'shrink-0');
                summaryToggle.innerHTML = `<svg class="transition-transform duration-1000 rotate-0 group-open:rotate-45 ease-primary" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.49414 15V0" stroke="#6B544F" style="stroke:#6B544F;stroke:color(display-p3 0.4196 0.3294 0.3098);stroke-opacity:1;"></path>
                        <path d="M-5.36442e-07 7.49316L15 7.49316" stroke="#6B544F" style="stroke:#6B544F;stroke:color(display-p3 0.4196 0.3294 0.3098);stroke-opacity:1;"></path>
                      </svg>`;
                mobileMenuSummary.appendChild(summaryToggle);
                mobileMenuDetails.appendChild(mobileMenuSummary);
                if (megaChildrenItems.length > 0) {
                  const mobileMenuDetailsContent = document.createElement('div');
                  mobileMenuDetailsContent.classList.add('pb-4');
                  const megaMenuItems = document.createElement('div');
                  megaChildrenItems.forEach((megaChildItem) => {
                    mobileMenuDetailsContent.appendChild(megaChildItem.cloneNode(true));
                  });
                  mobileMenuDetails.appendChild(mobileMenuDetailsContent);
                }
                mobileMenuContent.appendChild(mobileMenuDetails);
              }
            }
          }
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-donate"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Handles the logic for selecting a product variant on the product page.
    // This may include updating the displayed product information, price, images, and availability
    // based on the user's selection of different product options (such as size or color).
    function updateSelectedVariant() {
      var checkedOptions = document.querySelectorAll('[data-variant-option]:checked');
      var selectedOptions = Array.from(checkedOptions).map((option) => option.value);

      var isOtherSelected = Array.from(checkedOptions).some(function (option) {
        return option.dataset.otherOption === 'true';
      });

      var quantityContainer = document.querySelector('[data-quantity-container]');
      var quantityInput = document.querySelector('[data-quantity-input]');

      if (isOtherSelected) {
        if (quantityInput && quantityContainer) {
          quantityContainer.classList.remove('hidden');
          quantityContainer.classList.add('flex'); // Or 'block' depending on desired layout
          quantityInput.value = ''; // Clear default value
          quantityInput.setAttribute('placeholder', 'Enter amount');
          quantityInput.focus();
        }
      } else {
        if (quantityInput) {
          quantityContainer.classList.add('hidden');
          quantityContainer.classList.remove('flex');
          quantityInput.value = '1'; // Reset to default
        }
      }

      // Find the variant that matches all selected options
      var matchingVariant = null;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);

        if (
          selectedOptions.length === variantOptions.length &&
          selectedOptions.every((option) => variantOptions.includes(option))
        ) {
          matchingVariant = variant;
          break;
        }
      }

      if (matchingVariant) {
        var selectedVariantInput = document.querySelector('[data-selected-variant]');
        if (selectedVariantInput) {
          selectedVariantInput.value = matchingVariant.id;
        }

        //console.log('Matching Variant:', matchingVariant);
      }
    }

    // Add event listeners to variant options
    document.querySelectorAll('[data-variant-option]').forEach(function (option) {
      option.addEventListener('change', updateSelectedVariant);
    });

    function updateSellingPlan() {
      var sellingPlans = document.querySelectorAll('[data-selling-plan-option]:checked');
      var selectedPlan = Array.from(sellingPlans).map((option) => option.value);
      var selectedPlanInput = document.querySelector('[data-selected-plan]');
      if (selectedPlanInput) {
        selectedPlanInput.value = selectedPlan;
      }
      //console.log('Selected Selling Plan:', selectedPlan);
    }

    // Add event listeners to selling plan options
    document.querySelectorAll('[data-selling-plan-option]').forEach(function (option) {
      option.addEventListener('change', updateSellingPlan);
    });

    // Initialize on page load
    updateSelectedVariant();
    updateSellingPlan();

    const addToCartButton = document.querySelector('[data-add-to-cart]');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', function (event) {
        event.preventDefault();
        const quantityInput = document.querySelector('[data-quantity-input]');
        if (quantityInput) {
          quantityInput.value = quantityInput.value.trim();
        }
        //console.log('Quantity Input Value:', quantityInput.value);
        //console.log('Quantity Input:', quantityInput ? quantityInput.value : 'N/A');
        if (quantityInput && (isNaN(quantityInput.value) || Number(quantityInput.value) <= 0)) {
          const quantityMessage = document.querySelector('[data-quantity-message]');
          if (quantityMessage) {
            quantityMessage.classList.remove('hidden');
          }
          return; // Prevent form submission
        } else {
          const quantityMessage = document.querySelector('[data-quantity-message]');
          if (quantityMessage) {
            quantityMessage.classList.add('hidden'); // Hide error message
          }
        }

        const form = this.closest('form');
        if (!form) return;

        const variantId = form.querySelector('[data-selected-variant]').value;
        const sellingPlanId = form.querySelector('[data-selected-plan]').value;
        const quantity = form.querySelector('input[name="quantity"]').value;

        // Clear the cart first
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(() => {
            // Then add the new item
            const formData = new FormData(form);
            return fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
            });
          })
          .then((response) => {
            if (response.ok) {
              // Redirect to checkout
              window.location.href = '/checkout';
            } else {
              return response.json().then((error) => {
                console.error('Error adding to cart:', error);
                // Optionally, display an error message to the user
              });
            }
          })
          .catch((error) => {
            console.error('Request failed:', error);
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-event"] && !Shopify.designMode) return;
  try {
    
  function showBookNowFallback(reason) {
    var target = document.getElementById('expapp-book-now-button');
    var fallback = document.getElementById('expapp-book-now-fallback');
    if (!fallback || (target && target.querySelector('.expapp-button'))) return;
    console.warn('Showing Book Now fallback: ' + reason);
    fallback.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var target = document.getElementById('expapp-book-now-button');
    if (!target) {
      console.warn('Skipping ExperiencesShopify.mountBookNowButton because the target element is missing.');
      return;
    }

    if (typeof ExperiencesShopify === 'undefined') {
      console.error('ExperiencesShopify is not defined.');
      showBookNowFallback('widget script failed to load');
      return;
    }

    if (typeof product === 'undefined' || product == null || product.id == null) {
      console.warn('Skipping ExperiencesShopify.mountBookNowButton because the product or product ID is missing.');
      return;
    }

    // The widget fetches availability from experiencesapp.services after mounting; if
    // that API is blocked the button never renders, so check again after a grace period.
    setTimeout(function () {
      showBookNowFallback('Book Now button did not render');
    }, 8000);

    if (target.dataset.expappMounted) {
      console.warn('Skipping ExperiencesShopify.mountBookNowButton because it is already mounted.');
      return;
    }

    target.dataset.expappMounted = true;

    try {
      ExperiencesShopify.mountBookNowButton({
        target: target,
        id: 'expapp-book-now-button',
        productId: product.id,
        previewFetchCount: 0,
        onComplete: () => {
          // Find the select element by its ID
          const multiSelect = document.getElementById('expapp-custom-field-5');

          // If the element exists and is a select input, enable multiple selections
          if (multiSelect && multiSelect.tagName === 'SELECT') {
            multiSelect.multiple = true;
          }

          // Find the text input by its ID
          const textInput = document.getElementById('expapp-custom-field-8');

          // If the element exists and is a text input, replace it with a checkbox
          if (textInput && textInput.type === 'text') {
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.id = textInput.id;
            checkbox.name = textInput.name;
            checkbox.value = 'true'; // Set a value to be sent when checked

            // Replace the text input with the new checkbox
            textInput.parentNode.replaceChild(checkbox, textInput);
          }
        },
      });
    } catch (error) {
      console.error(error);
      showBookNowFallback('mountBookNowButton threw');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-membership"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Handles the logic for selecting a product variant on the product page.
    // This may include updating the displayed product information, price, images, and availability
    // based on the user's selection of different product options (such as size or color).
    function updateSelectedVariant() {
      var checkedOptions = document.querySelectorAll('[data-variant-option]:checked');
      var selectedOptions = Array.from(checkedOptions).map((option) => option.value);

      // Find the variant that matches all selected options
      var matchingVariant = null;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);

        if (
          selectedOptions.length === variantOptions.length &&
          selectedOptions.every((option) => variantOptions.includes(option))
        ) {
          matchingVariant = variant;
          break;
        }
      }

      if (matchingVariant) {
        var selectedVariantInput = document.querySelector('[data-selected-variant]');
        if (selectedVariantInput) {
          selectedVariantInput.value = matchingVariant.id;
        }

        // Logic to show/hide selling plan groups based on variant
        var annualGroup = document.querySelector('[data-selling-plan-group="fotag-annual-membership"]');
        var threeYearGroup = document.querySelector('[data-selling-plan-group="three-year-friends-membership"]');

        // Check if the selected variant is "Three Year Membership" (by title or handle)
        var isThreeYearVariant = matchingVariant.title.toLowerCase().includes('three year');

        if (annualGroup) {
          annualGroup.classList.toggle('hidden', isThreeYearVariant);
        }
        if (threeYearGroup) {
          threeYearGroup.classList.toggle('hidden', !isThreeYearVariant);
        }

        // Auto-select and update prices for the VISIBLE group
        var visiblePlans = document.querySelectorAll(
          '[data-selling-plan-group]:not(.hidden) [data-selling-plan-option]'
        );
        if (visiblePlans.length > 0) {
          // If no plan is checked in the visible group, check the first one
          var currentChecked = Array.from(visiblePlans).find((p) => p.checked);
          if (!currentChecked) {
            visiblePlans[0].checked = true;
          }
          updateSellingPlan(); // Sync the hidden input
        }

        var sellingPlanOptions = document.querySelectorAll('[data-selling-plan-option]');
        sellingPlanOptions.forEach(function (planOption) {
          var planId = planOption.value;
          var priceElement = planOption.nextElementSibling.querySelector('[data-plan-price]');

          if (priceElement) {
            var allocation = matchingVariant.selling_plan_allocations.find(function (alloc) {
              return alloc.selling_plan_id == planId;
            });

            if (allocation) {
              var price = allocation.price / 100;
              priceElement.textContent = priceFormat.format(price) + ' /';
            } else {
              priceElement.textContent = '';
            }
          }
        });
      }
    }

    // Add event listeners to variant options
    document.querySelectorAll('[data-variant-option]').forEach(function (option) {
      option.addEventListener('change', updateSelectedVariant);
    });

    function updateSellingPlan() {
      var sellingPlans = document.querySelectorAll('[data-selling-plan-option]:checked');
      var selectedPlan = Array.from(sellingPlans).map((option) => option.value);
      var selectedPlanInput = document.querySelector('[data-selected-plan]');
      if (selectedPlanInput) {
        selectedPlanInput.value = selectedPlan;
      }
      //console.log('Selected Selling Plan:', selectedPlan);
    }

    // Add event listeners to selling plan options
    document.querySelectorAll('[data-selling-plan-option]').forEach(function (option) {
      option.addEventListener('change', updateSellingPlan);
    });

    // Initialize on page load
    updateSelectedVariant();
    updateSellingPlan();

    const checkoutButton = document.querySelector('[data-checkout-button]');
    // Toggle shipping address fields when the customer indicates billing equals shipping.
    const sameAddressCheckbox = document.querySelector('[data-same-address-checkbox]');
    const addressContainer = document.querySelector('[data-address-container]');

    if (sameAddressCheckbox && addressContainer) {
      const tabsContainer = addressContainer.querySelector('[data-address-tabs]');
      const tabs = addressContainer.querySelectorAll('[data-address-tab]');
      const panels = addressContainer.querySelectorAll('[data-address-panel]');
      const shippingPanel = addressContainer.querySelector('[data-address-panel="shipping"]');
      const shippingInputs = shippingPanel.querySelectorAll('input, select');

      function setPanelVisibility(activeTab) {
        panels.forEach((panel) => {
          const isShippingPanel = panel.dataset.addressPanel === 'shipping';
          const isHidden = panel.dataset.addressPanel !== activeTab;
          panel.classList.toggle('hidden', isHidden);
          panel.classList.toggle('flex', !isHidden);
          panel.setAttribute('aria-hidden', isHidden);
          if (isShippingPanel) {
            shippingInputs.forEach((input) => (input.disabled = isHidden));
          }
        });
      }

      function updateTabUI(activeTab) {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.addressTab === activeTab;
          tab.setAttribute('aria-selected', isActive);
          tab.classList.toggle('bg-primary', isActive);
          tab.classList.toggle('text-white', isActive);
          tab.classList.toggle('bg-transparent', !isActive);
          tab.classList.toggle('text-primary', !isActive);
        });
      }

      function handleTabSwitching() {
        const isSameAddress = sameAddressCheckbox.checked;
        tabsContainer.classList.toggle('hidden', isSameAddress);

        if (isSameAddress) {
          // If same address, show only billing panel and disable shipping inputs
          setPanelVisibility('billing');
          shippingInputs.forEach((input) => (input.disabled = true));
        } else {
          // If different addresses, show tabs and set initial state
          const selectedTab = tabsContainer.querySelector('[aria-selected="true"]').dataset.addressTab;
          updateTabUI(selectedTab);
          setPanelVisibility(selectedTab);
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const targetPanel = tab.dataset.addressTab;
          updateTabUI(targetPanel);
          setPanelVisibility(targetPanel);
        });
      });

      sameAddressCheckbox.addEventListener('change', handleTabSwitching);
      // Initial setup
      handleTabSwitching();
    }

    if (checkoutButton) {
      checkoutButton.addEventListener('click', function (event) {
        event.preventDefault();

        const form = this.closest('form');
        if (!form) return;

        const formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then((response) => {
            if (response.ok) {
              window.location.href = '/checkout';
            } else {
              return response.json().then((error) => {
                console.error('Error adding to cart:', error);
                // Optionally, display an error message to the user
              });
            }
          })
          .catch((error) => {
            console.error('Request failed:', error);
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-patron"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Handles the logic for selecting a product variant on the product page.
    // This may include updating the displayed product information, price, images, and availability
    // based on the user's selection of different product options (such as size or color).
    function updateSelectedVariant() {
      var checkedOptions = document.querySelectorAll('[data-variant-option]:checked');
      var selectedOptions = Array.from(checkedOptions).map((option) => option.value);

      // Find the variant that matches all selected options
      var matchingVariant = null;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);

        if (
          selectedOptions.length === variantOptions.length &&
          selectedOptions.every((option) => variantOptions.includes(option))
        ) {
          matchingVariant = variant;
          break;
        }
      }

      if (matchingVariant) {
        var selectedVariantInput = document.querySelector('[data-selected-variant]');
        if (selectedVariantInput) {
          selectedVariantInput.value = matchingVariant.id;
        }

        //console.log('Matching Variant:', matchingVariant);
      }

      if (matchingVariant) {
        var sellingPlanOptions = document.querySelectorAll('[data-selling-plan-option]');
        var sellingPlanGroups = product.selling_plan_groups;

        var activeSellingPlans = [];

        sellingPlanOptions.forEach(function (planOption) {
          //console.log('Plan Option:', planOption);
          //console.log('Matching Variant Selling Plans:', matchingVariant.selling_plan_allocations);

          if (matchingVariant.selling_plan_allocations.length > 0) {
            matchingVariant.selling_plan_allocations.forEach((allocation) => {
              if (planOption.value == allocation.selling_plan_id) {
                activeSellingPlans.push(planOption.value);
              }
            });
          }
          var planId = planOption.value;
          var priceElement = planOption.nextElementSibling.querySelector('[data-plan-price]');

          if (priceElement) {
            var allocation = matchingVariant.selling_plan_allocations.find(function (alloc) {
              return alloc.selling_plan_id == planId;
            });

            if (allocation) {
              // The allocation.price is the final price calculated by Shopify for the subscription.
              var price = allocation.price / 100;
              priceElement.textContent = priceFormat.format(price) + ' /';
            } else {
              // Fallback if no specific allocation is found for this variant and plan combination.
              // This part might need adjustment based on desired behavior for unavailable plans.
              priceElement.textContent = '';
            }
          }
        });

        var sellingPlanOptionsArray = Array.from(sellingPlanOptions);

        var activePlanOptions = sellingPlanOptionsArray.filter(function (planOption) {
          return activeSellingPlans.includes(planOption.value);
        });

        sellingPlanOptions.forEach(function (planOption) {
          if (activeSellingPlans.includes(planOption.value)) {
            planOption.disabled = false;
            planOption.parentElement.classList.remove('hidden', 'pointer-events-none');
            planOption.parentElement.classList.add('block', 'pointer-events-auto');
          } else {
            planOption.disabled = true;
            planOption.parentElement.classList.add('hidden', 'pointer-events-none');
            planOption.parentElement.classList.remove('block', 'pointer-events-auto');
            if (planOption.checked) {
              planOption.checked = false;
            }
          }

          // If there are active plans and the currently checked one is not among them,
          // check the first available active plan.
          var currentlyChecked = document.querySelector('[data-selling-plan-option]:checked');
          if (
            activePlanOptions.length > 0 &&
            (!currentlyChecked || !activeSellingPlans.includes(currentlyChecked.value))
          ) {
            var firstActivePlan = activePlanOptions[0];
            firstActivePlan.checked = true;
            // Manually trigger the change event to update UI and dependent logic
            firstActivePlan.dispatchEvent(new Event('change'));
          } else if (activePlanOptions.length === 0 && currentlyChecked) {
            // If no plans are active, uncheck any selected plan
            currentlyChecked.checked = false;
            currentlyChecked.dispatchEvent(new Event('change'));
          }
        });
      }
    }

    // Add event listeners to variant options
    document.querySelectorAll('[data-variant-option]').forEach(function (option) {
      option.addEventListener('change', updateSelectedVariant);
    });

    function updateSellingPlan() {
      var sellingPlans = document.querySelectorAll('[data-selling-plan-option]:checked');
      var selectedPlan = Array.from(sellingPlans).map((option) => option.value);
      var selectedPlanInput = document.querySelector('[data-selected-plan]');
      if (selectedPlanInput) {
        selectedPlanInput.value = selectedPlan;
      }
      //console.log('Selected Selling Plan:', selectedPlan);
    }

    // Add event listeners to selling plan options
    document.querySelectorAll('[data-selling-plan-option]').forEach(function (option) {
      option.addEventListener('change', updateSellingPlan);
    });

    // Initialize on page load
    updateSelectedVariant();
    updateSellingPlan();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  function initRelatedProducts(container) {
    var relatedProducts = container || document.querySelector('[data-related-products]');
    if (!relatedProducts) return;

    var dataUrl = relatedProducts.getAttribute('data-url');
    if (!dataUrl) return;

    fetch(dataUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const check = html.querySelector('.swiper, .editor-message');
        if (!check) {
          relatedProducts.innerHTML = '';
          return;
        }
        relatedProducts.classList.remove('hidden');

        const recommendations = html.querySelector('[data-related-products]');
        if (recommendations && recommendations.innerHTML.trim().length) {
          relatedProducts.innerHTML = recommendations.innerHTML;
          var productCarousels = relatedProducts.querySelectorAll('[data-carousel="product"]');

          productCarousels.forEach(function (carousel) {
            var el = carousel.querySelector('[data-carousel="element"]');
            if (!el) return;

            const breakpoints = {
              1024: {
                slidesPerView: 'auto',
                spaceBetween: 16,
              },
            };
            if (el.getAttribute('data-type') === 'event') {
              breakpoints[1024] = {
                slidesPerView: 'auto',
                spaceBetween: 30,
              };
            }

            new Swiper(el, {
              slidesPerView: 'auto',
              spaceBetween: 10,
              mousewheel: {
                enable: true,
                forceToAxis: true,
              },
              breakpoints: { ...breakpoints },
            });
          });
        }
      })
      .catch((e2) => {
        console.error(e2);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRelatedProducts();
  });

  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target.querySelector('[data-related-products]');
    if (container) {
      initRelatedProducts(container);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var eventCarousels = document.querySelectorAll('[data-carousel="events"]');
    if (eventCarousels.length > 0) {
      eventCarousels.forEach(function (eventCarousel) {
        const breakpoints = {
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 16,
          },
        };
        if (eventCarousel.getAttribute('data-type') === 'event') {
          breakpoints[1024] = {
            slidesPerView: 'auto',
            spaceBetween: 30,
          };
        }
        new Swiper(eventCarousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          mousewheel: {
            enable: true,
            forceToAxis: true,
          },
          breakpoints: { ...breakpoints },
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var galleryEl = document.querySelectorAll('[data-product-gallery]');
    if (galleryEl.length > 0) {
      galleryEl.forEach(function (gallery) {
        new Swiper(gallery, {
          slidesPerView: 1,
          spaceBetween: 0,
          mousewheel: {
            enable: true,
            forceToAxis: true,
          },
          navigation: {
            nextEl: gallery.querySelector('[data-gallery-next]'),
            prevEl: gallery.querySelector('[data-gallery-prev]'),
          },
        });
      });
    }

    const quantitySelector = document.querySelector('.quantity-selector');
    if (quantitySelector) {
      const quantityInput = quantitySelector.querySelector('[data-quantity-input]');
      const minusButton = quantitySelector.querySelector('[data-quantity-minus]');
      const plusButton = quantitySelector.querySelector('[data-quantity-plus]');
      const hiddenQuantityInput = document.querySelector('form[action="/cart/add"] input[name="quantity"]');

      const updateQuantity = (newQuantity) => {
        quantityInput.value = newQuantity;
        if (hiddenQuantityInput && hiddenQuantityInput !== quantityInput) {
          hiddenQuantityInput.value = newQuantity;
        }
      };

      minusButton.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value, 10);
        if (currentValue > 1) {
          updateQuantity(currentValue - 1);
        }
      });

      plusButton.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value, 10);
        updateQuantity(currentValue + 1);
      });

      quantityInput.addEventListener('change', () => {
        let currentValue = parseInt(quantityInput.value, 10);
        if (isNaN(currentValue) || currentValue < 1) {
          currentValue = 1;
        }
        updateQuantity(currentValue);
      });
    }
    // Handles the logic for selecting a product variant on the product page.
    // This may include updating the displayed product information, price, images, and availability
    // based on the user's selection of different product options (such as size or color).
    function updateSelectedVariant() {
      var checkedOptions = document.querySelectorAll('[data-variant-option]:checked');
      var selectedOptions = Array.from(checkedOptions).map((option) => option.value);

      // Find the variant that matches all selected options
      var matchingVariant = null;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);

        if (
          selectedOptions.length === variantOptions.length &&
          selectedOptions.every((option) => variantOptions.includes(option))
        ) {
          matchingVariant = variant;
          break;
        }
      }

      if (matchingVariant) {
        var selectedVariantInput = document.querySelector('[data-selected-variant]');
        if (selectedVariantInput) {
          selectedVariantInput.value = matchingVariant.id;
        }

        //console.log('Matching Variant:', matchingVariant);
      }
    }

    // Add event listeners to variant options
    document.querySelectorAll('[data-variant-option]').forEach(function (option) {
      option.addEventListener('change', updateSelectedVariant);
    });

    function updateSellingPlan() {
      var sellingPlans = document.querySelectorAll('[data-selling-plan-option]:checked');
      var selectedPlan = Array.from(sellingPlans).map((option) => option.value);
      var selectedPlanInput = document.querySelector('[data-selected-plan]');
      if (selectedPlanInput) {
        selectedPlanInput.value = selectedPlan;
      }
      //console.log('Selected Selling Plan:', selectedPlan);
    }

    // Add event listeners to selling plan options
    document.querySelectorAll('[data-selling-plan-option]').forEach(function (option) {
      option.addEventListener('change', updateSellingPlan);
    });

    // Initialize on page load
    updateSelectedVariant();
    updateSellingPlan();

    function updatePrice() {
      const checkedOptions = document.querySelectorAll('[data-variant-option]:checked');
      const selectedOptions = Array.from(checkedOptions).map((option) => option.value);

      const matchingVariant = variants.find((variant) => {
        const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
        return (
          selectedOptions.length === variantOptions.length &&
          selectedOptions.every((option) => variantOptions.includes(option))
        );
      });

      if (!matchingVariant) {
        return;
      }

      const selectedPlanInput = document.querySelector('[data-selling-plan-option]:checked');
      const selectedPlanId = selectedPlanInput ? selectedPlanInput.value : null;

      const priceEl = document.querySelector('[data-product-price]');
      const compareAtPriceEl = document.querySelector('[data-product-compare-at-price]');
      const addToCartWrapper = document.querySelector('[data-add-to-cart-wrapper]');

      let price;
      let compareAtPrice;

      if (selectedPlanId) {
        const allocation = matchingVariant.selling_plan_allocations.find(
          (alloc) => alloc.selling_plan_id == selectedPlanId
        );
        if (allocation) {
          price = allocation.price;
          compareAtPrice = allocation.compare_at_price;
        }
      }

      if (price === undefined) {
        price = matchingVariant.price;
        compareAtPrice = matchingVariant.compare_at_price;
      }

      if (priceEl) {
        priceEl.textContent = price === 0 ? labelFree : priceFormat.format(price / 100);
      }

      if (compareAtPriceEl) {
        if (compareAtPrice > price) {
          compareAtPriceEl.textContent = priceFormat.format(compareAtPrice / 100);
          compareAtPriceEl.style.display = 'inline';
        } else {
          compareAtPriceEl.style.display = 'none';
        }
      }

      if (addToCartWrapper) {
        if (matchingVariant.available) {
          addToCartWrapper.classList.remove('is-unavailable');
          addToCartWrapper.classList.add('is-available');
        } else {
          addToCartWrapper.classList.remove('is-available');
          addToCartWrapper.classList.add('is-unavailable');
        }
      }
    }

    if (typeof updatePrice === 'function') {
      document.querySelectorAll('[data-variant-option], [data-selling-plan-option]').forEach((input) => {
        input.addEventListener('change', () => {
          updateSelectedVariant();
          updateSellingPlan();
          updatePrice();
        });
      });

      // Initial price update on load
      updatePrice();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
